import { render, staticRenderFns } from "./MembershipAgreement.vue?vue&type=template&id=6512fbfa&"
import script from "./MembershipAgreement.vue?vue&type=script&lang=js&"
export * from "./MembershipAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports